// export default {
//     'fontUrl':"http://brightness.mynetgear.com:8081",
//     'backendUrl':'http://brightness.mynetgear.com:8081',
//     "baseFileUrl":"/hz/frontCommon/upload",
//     "uploadExcelUrl":"/hz/frontAudience/info/excelBatchUploading",
//     "uploadExcelAudience":"/hz/frontExhibitor/populationInvite/excelBatchUploading",
//     "editPrefix":"/hzTestHoutai",
//     "backFront": "http://brightness.mynetgear.com:8081/hzTest/#/index",
//     "registUrl": "http://brightness.mynetgear.com:8081/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33",
//     "backProductDetail": "http://brightness.mynetgear.com:8081/hzTest/#/exhibItem_detail",
//     "backActivityDetail": "http://brightness.mynetgear.com:8081/hzTest/#/active_detail",
//     "backLiveDetail":"http://brightness.mynetgear.com:8081/hzTest/#/live_detail",
//     "backExhibitorDetail":"http://brightness.mynetgear.com:8081/hzTest/#/exhibition_det",
//     "backExhibitionList":"http://brightness.mynetgear.com:8081/hzTest/#/exhibition",
// }


//展会官网主域名
let baseUrl = "https://www.chinaminexpo.com";
let onlineUrl  = "https://e-show.chinaminexpo.com";

export default {
  fontUrl: baseUrl,
  backendUrl: baseUrl,  
  baseFileUrl: '/hz/frontCommon/upload',
  uploadExcelUrl: '/hz/frontAudience/info/excelBatchUploading',
  uploadExcelAudience: '/hz/frontExhibitor/populationInvite/excelBatchUploading',
  editPrefix: '/exhibitor',
  tinymceUrl:onlineUrl,  //富文本静态路径
  backFront: onlineUrl+'/#/index',
  registUrl: baseUrl+'/hz/f/list.html?categoryId=423d542b5b2343f1ac216b425aa7ae33',
  backProductDetail: onlineUrl+'/#/exhibItem_detail',
  backActivityDetail: onlineUrl+'/#/active_detail',
  backLiveDetail: onlineUrl+'/#/live_detail',
  backExhibitorDetail: onlineUrl+'/#/exhibition_det',
  backExhibitionList: onlineUrl+'/#/exhibition',
  adminLogin: onlineUrl+"/visitor/#/adminLogin",
  axiosBaseUrl: baseUrl+'/hz',
  exhibitionList:onlineUrl+"/#/",//线上展会地址,用于移动版首页"查看更多"中链接到线上展会
};
